import { InstaImage, InstaProfileINT } from "../../src/components/insta/interfaces";
import Character from "../../src/shell/Character";
import Game from "../../src/shell/Game";
import ImageClass, { ImageObject, ImageOptions } from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import SoundClass from "../../src/shell/Sound";
import { TimageINT, TtalkStateINTOptions, setGlobalQuestions } from "../../src/store/slices/gameObjectSlice";
import { store } from "../../src/store/store";
import { Logger } from "../../src/utils/Logger";
import { ann } from "../characters/Ann";
import { mc } from "../characters/MC";
import { empty } from "../characters/empty";
import { extras, images } from "../story/images";
import { sounds } from "../story/sounds";
import { getComments } from "./InstaComments";
import { getThoughts } from "./InstaThoughts";

export const getInstaProfile = (char: Character<any>, options?: Partial<InstaProfileINT> | undefined): InstaProfileINT => {
    const { profiles } = store.getState().insta.present;
    return {
        key: char.name,
        instaProfileName: char.properties.instaNickName,
        instaProfileImage: options?.instaProfileImage || char?.properties?.instaProfileImage || profiles?.[char.name]?.instaProfileImage,
        following: options?.following || profiles?.[char.name]?.following || 5,
        followers: options?.followers || profiles?.[char.name]?.followers || 2,
        description: options?.description || profiles?.[char.name]?.description || char?.properties?.instaDescription,
        images: []
    };
};

export const getImagePost = (imagesList: ImageObject, profile: InstaProfileINT | null, id: string, options?: Partial<InstaImage>): InstaImage => {
    if (!id) { throw new Error(`Must give a valid id to get insta post got ${id}`); }
    if (!(imagesList)[id]) { throw new Error(`Image does not exists for post ${id}`); }
    const image = profile?.images.find(image => image.key === id);

    return {
        key: id,
        image: ((imagesList)[id]),
        comments: getComments(id),
        mcSeen: image?.mcSeen || false,
        thoughts: getThoughts(id),
        mcComments: options?.mcComments || image?.mcComments || [],
        likes: options?.likes || image?.likes || 2,
        mcLiked: image?.mcLiked || false
    };
};
export const setMinLikes = (likes: number, min: number, max: number) => {
    if (likes < min) {

        return (likes + random(min, max));
    }
    return likes;
};
export const doTransition = (image: Partial<TimageINT>, options?: ImageOptions | null, waitTime = 1.2) => {
    ImageClass.setImage(images.v2_5.BlackScreen, { duration: waitTime, wait: waitTime, hideText: true, effect: true, ...options });
    ImageClass.setImage(image, { duration: 1, wait: 1, ...options });
};

export const doWaitImageByTime = (image: Partial<TimageINT>, options?: ImageOptions | null, delay: number = 1) => {
    // image.partialsToDisplay[image.partialsToDisplay.length - 1].options = { ...image.partialsToDisplay[image.partialsToDisplay.length - 1].options, ...image.options };
    if (image.partialsToDisplay?.length) {
        return ImageClass.setImage({ ...image, partialsToDisplay: image.partialsToDisplay.map(partial => { return { ...partial, options: { wait: delay, hideText: true, duration: delay } }; }) }, { duration: delay, wait: delay, hideText: true, ...options });
    }
    ImageClass.setImage(image, { duration: delay, wait: delay, hideText: true, ...options });
};
export const doPutMultipleImages = (images: TimageINT[], options?: ImageOptions) => {
    ImageClass.setImage({ ...images[0], partialsToDisplay: [...images.slice(1)] }, options);

};
export const doImageShake = (_image: TimageINT, options?: ImageOptions) => {
    ImageClass.setImage(_image, { duration: 0, shake: true, ...options });
};
export const doPutBlackImage = (options?: ImageOptions) => {
    ImageClass.setImage(images.v2_5.BlackScreen, options);
};
export const doLoopImages = (_images: TimageINT[], intervalSeconds: number = 1, duration?: number, options?: ImageOptions) => {
    const firstImage = _images.shift();
    ImageClass.setImage({
        ...firstImage, loopingImages:
            _images
    }, { looping: intervalSeconds * 1000, duration: duration, ...options });



};
export const updateVariables = (variable: string, value: any) => {
    store.dispatch(setGlobalQuestions({ ...Question.globalAnswers, [variable]: value }));
};

export const getInstaImage = (profile: InstaProfileINT | undefined, imageName: string): InstaImage | null => {
    if (!profile) {
        return null;
    }
    return profile.images.filter(image => image.key.toLocaleLowerCase() === imageName.toLocaleLowerCase())[0];

};

export function random(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
export function randomFloat(min: number, max: number) {
    return (Math.random() * (max - min + 1)) + min;
};
export const checkWordInArray = (word: string, matchString: string) => {
    const splitted = matchString.split(' ');
    return splitted.every(wordInArr => {
        if (word.includes(wordInArr)) {
            return true;
        }
        return false;
    });
};
export function checkCurrentImage(image: TimageINT, imageToCheck: TimageINT) {
    if (!imageToCheck.key) { Logger.log("WARNING - image without a key!", imageToCheck); }
    return image.key === imageToCheck.key;
}

export function doPhoneRing() {
    // TODO: add phone sound
    empty.think(`*Ring Ring*`);
}
export function doDoorRing() {
    // TODO: add phone sound
    empty.think(`*Ding Dong*`);
}
export function doDoorKnock() {
    // TODO: knock sound
    empty.think(`*Knock Knock Knock*`);
}
export const doTakePhoto = () => {

    // TODO: pic sound for all of the images taken
    ImageClass.setImage(extras.WhiteScreen, { wait: 0.2, duration: 0.2 });
};
export async function doSmsSound(options?: TtalkStateINTOptions) {
    // TODO: add sms sound
    // SoundClass.startSound(sounds.phone_message, { shouldPlay: true });
    empty.think(`*SMS sound*`, { ...options });
}

export const isJoeEnemy = () => {
    if (mc?.properties?.joeStatus === "enemy") {
        return true;
    }
    return false;

};
export const isAnnCorrupted = () => {
    if (ann?.properties?.isCorrupted) {
        return true;
    }
    return false;

};
export const isMcDressed = () => {
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_Question_Refuse`) || mc.properties.joeStatus === "enemy") {
        return true;
    }
    return false;

};
export const isVanessaDressed = () => {
    if (Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival_Listen_Question`)) {
        return true;
    }
    return false;

};
export const isDatingJenny = () => {
    return Question.globalAnswers.v5JoeyBeachTookJennysNumber || Question.globalAnswers.v7JoeRivalOfferJennyRide;
};


export function isAgreedToChrisProposal() {
    return (Question.globalAnswers.v4AgreedToChrisProposal || Question.globalAnswers.v6AgreedToChrisProposal || Question.globalAnswers.v7JennyDateAgreeToChrisProposal);

}

export function isMCCheatedWithVanessa() {
    return (
        Question.globalAnswers.v6HadSexVanessaLivingRoom ||
        mc.properties.v8WentToThreesome ||
        Question.globalAnswers.v3VanessaCoffeeJustSuckIt ||
        Question.globalAnswers.v4SexTapeFuckedVanessa ||
        Question.globalAnswers.v8VanessaNightFuckHer ||
        Question.globalAnswers.v8VanessaNightFingeredHer ||
        Question.globalAnswers.v8VanessaNightLickHer ||
        Question.globalAnswers.v7AteVanessaPussy ||
        Question.globalAnswers.v9VanessaBusMcLeadingAskHerToTouchCock
    );

}
export function isMCCheatedWithAmber() {
    return Question.globalAnswers.v7ReturningOutfitMcAmberLickHerPussy;

}
export function isMCCheatedWithAngela() {
    return Question.globalAnswers.v8FuckedAngela;

}
export function isMCCheatedWithJenny() {
    return (
        Question.globalAnswers.v7JennyDateKissedHer ||
        Question.globalAnswers.v8JennyDateKissedHer ||
        Question.globalAnswers.v8JennyDateTouchedBreasts
    );

}
export function isMCCheatedWithMerry() {
    return (

        Question.globalAnswers.v5FuckedMerryAss ||
        //got only BJ
        Question.globalAnswers.v5FuckedMerryAss === false
    );

}
export function isMCCheated() {
    return (
        isMCCheatedWithVanessa() ||
        isMCCheatedWithAmber() ||
        isMCCheatedWithAngela() ||
        isMCCheatedWithJenny() ||
        isMCCheatedWithMerry()

    );
}
export function isMcLikesNTR() {
    if (Question.globalAnswers.todAnnAsksWhyKissJoe === "IlikeSeeingYouWithOthers" ||
        Question.globalAnswers.v3VanessaCoffeeLikedWatchingVanessaJoeFuck ||
        Question.globalAnswers.v7AnnChrisMoviesAgreeToChrisTouchingHer ||
        Question.globalAnswers.v8AnnChrisTextingSaidHeLovedIt ||
        mc.properties.v8AnnNightMCParticipated === false ||
        Question.globalAnswers.v8AnnChrisAgreeCoffeeBlowjob ||
        Question.globalAnswers.v9AnnDormNightChrisMasturbated

    ) {
        return true;
    }
    return false;
}
export function isAnnGF() {
    return mc?.properties.annStatus === "gf" || mc.properties.annLateGF;

}
export function isAnnHate() {
    return mc?.properties.annStatus === "hate" || mc.properties.annLateHate;

}

export function wasJoeEnemy() {
    return Question.globalAnswers.v7JoeRivalTextResponse === "metJoey";

}

export function isAnnGFAndCorrupted() {
    return isAnnGF() && isAnnCorrupted();
}
export function isFollowingVanessaLead() {
    // New variable. So if it doesn't exists, count on the old one like I did before it was added
    if (Question.globalAnswers.v7VanessaConvAgreeSheIsPerfect && Question.globalAnswers.v7VanessaConvAgreeToVanessaBet === undefined) {
        return true;
    }
    // Otherwise use the new variable.
    return !!Question.globalAnswers.v7VanessaConvAgreeToVanessaBet;
}
export function isAnnDidAnalWithMC() {
    return Question.globalAnswers.v8AnnCorAfterLibraryFuckHerAss;

}
export function isAnnDidAnalWithChris() {
    return (Question.globalAnswers.V8AnnDateMCOkWithChris && (
        Question.globalAnswers.V1NtrUnexpected || Question.globalAnswers.v8AnnChrisHouseToldChrisAnalDetails));

}
export function isAnnDidAnal() {
    return isAnnDidAnalWithChris() || isAnnDidAnalWithMC();
}


export function isAnnFuckedMCAndChrisTogether() {
    return ((empty.properties.v8AnnChrisStateCounter?.doggychris || empty.properties.v8AnnChrisStateCounter?.ridingchris) &&
        empty.properties.v8AnnChrisStateCounter?.doggymc || empty.properties.v8AnnChrisStateCounter?.ridingmc);
}
export function isAnnMotelHadSexWithBothGuys() {
    return Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mc";

}
export function isAnnMotelHadSexWithTyler() {
    return (Game.seenScenarios.includes("V9AnnMCMotel_InviteGuys_MCNotSofa_MCSleeping") || Game.seenScenarios.includes("V9AnnMCMotel_InviteGuys_MCNotSofa_FoolAroundWithHim")) && Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mike";

}
export function isAnnMotelHadSexWithMike() {
    return (Game.seenScenarios.includes("V9AnnMCMotel_InviteGuys_MCNotSofa_MCSleeping") || Game.seenScenarios.includes("V9AnnMCMotel_InviteGuys_MCNotSofa_FoolAroundWithHim")) && Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "tyler";
}
export function isMCFlirtingWithAlex() {
    return (
        Question.globalAnswers.V8AlexRoomHuggedHer ||
        Question.globalAnswers.v5ToldAnnAlexIsHot ||
        Question.globalAnswers.V6AlexEasterToldHerSheIsHot ||
        Question.globalAnswers.V7AlexAnnMCCheckedOutAlex ||
        Question.globalAnswers.V8AlexHomeComplimentedOnDress ||
        Question.globalAnswers.V6AlexEasterWhatMCSent === "nude" ||
        Question.globalAnswers.V6AlexEasterWhatMCSent === "tease" ||
        Question.globalAnswers.v7AlexMovingComplimentHer ||
        Question.globalAnswers.v9AlexDateExposedHerBreasts ||
        Question.globalAnswers.v9AlexDateSunsetLookedAtAlex
    );
}

